import { defineMessages, MessageDescriptor } from 'react-intl';

import { MeditationType, Program } from '@/store/program/types';

export type Personnel = {
	id: string;
	image?: string;
	heading: MessageDescriptor;
	copy?: string;
};

const messages = defineMessages({
	composerTitle: {
		id: 'guideInfo.composer.title',
		defaultMessage: 'Composer',
		description: 'A descriptor of who composed a piece of music',
	},
	authorTitle: {
		id: 'guideInfo.author.title',
		defaultMessage: 'Author',
		description: 'Descriptor for who authored a particular story',
	},
	narratorTitle: {
		id: 'guideInfo.narrator.title',
		defaultMessage: 'Narrator',
		description: 'Descriptor for who is narrating a story',
	},
	instructorTitle: {
		id: 'guideInfo.instructor.title',
		defaultMessage: 'Instructor',
		description: 'Descriptor for who is instructing a story',
	},
	hostTitle: {
		id: 'guideInfo.host.title',
		defaultMessage: 'Host',
		description: 'Descriptor for who is the host of the content',
	},
	artistTitle: {
		id: 'guideInfo.artist.title',
		defaultMessage: 'Artist',
		description: 'Descriptor for who is the artist of the content',
	},
	guestTitle: {
		id: 'guideInfo.guest.title',
		defaultMessage: 'Guest',
		description: 'Descriptor for who is the host of the content',
	},
});

export const getNarratorDisplayTitle = (program: Program) => {
	if (program.meditation_type === MeditationType.MasterClass) {
		return messages.instructorTitle;
	}

	if (
		program.meditation_type === MeditationType.Music ||
		program.meditation_type === MeditationType.Soundscape
	) {
		return messages.artistTitle;
	}

	if (program.narrator?.is_composer) {
		return messages.composerTitle;
	}

	return messages.narratorTitle;
};

export const getGuidePersonnel = (program: Program): Personnel[] => {
	return [
		{
			id: 'narrator',
			image: program.narrator?.headshot?.url,
			heading: getNarratorDisplayTitle(program),
			copy: program.narrator?.name,
		},
		{
			id: 'author',
			copy: program.author?.name,
			heading: messages.authorTitle,
		},
		{
			id: 'host',
			copy: program.host?.name,
			heading: messages.hostTitle,
		},
		{
			id: 'guest',
			copy: program.guest?.name,
			heading: messages.guestTitle,
		},
	].filter(person => person.copy !== undefined);
};
